import { Injectable } from '@angular/core';

@Injectable()
export class VehicleInfoService {
    public obj:object = {}
    constructor() { }

    public urlDataFromLink = {
        'hookURL': '', 'urlFlag': '', 'language': '', 'configurationDate': '', 'orderingMarket': '',
        'pricingDate': '', 'salesLevel': '', 'taxDate': '', 'materialType': '', 'plant': '', 'baumuster': '',
        'internalVehicleId': '', 'savedConfig': '', 'productionDate': '', 'vehicleDescription': '',
        'vehicleClass': '', 'preSeriesModeFlag': '', 'driveType': '', 'materialGroupExt': '',
        'requestedProductionDate' :'', 'authToken': ''
    }
    extractData() {
        
        let x = window.location.search.replace(/\+/g, '%20');
        let uricomponents = decodeURIComponent(x).substring(1).split('&');
        for (let i = 0; i < uricomponents.length; i++) {
            let pair = uricomponents[i].split('=');
            if (pair[0] === 'savedConfig') {
                if (JSON.stringify(pair[1]) !== '\"\"') {
                    this.urlDataFromLink.savedConfig = pair[1];
                } else {
                    this.urlDataFromLink.savedConfig = '';
                }
            } else
                if (pair[0] === 'urlFlag') {
                    this.urlDataFromLink.urlFlag = pair[1];
                } else if (pair[0] === 'materialType') {
                    this.urlDataFromLink.materialType = pair[1];
                } else if (pair[0] === 'productIdERP') {
                    this.urlDataFromLink.baumuster = pair[1];
                } else if (pair[0] === 'pricingDate') {
                    this.urlDataFromLink.pricingDate = pair[1];
                } else if (pair[0] === 'configurationDate') {
                    this.urlDataFromLink.productionDate = pair[1];
                }else if (pair[0] === 'requestedProductionDate') {
                    this.urlDataFromLink.requestedProductionDate = pair[1];
                } else if (pair[0] === 'orderingMarket') {
                    this.urlDataFromLink.orderingMarket = pair[1];
                } else if (pair[0] === 'language') {
                    this.urlDataFromLink.language = pair[1];
                } else if (pair[0] === 'salesLevel') {
                    this.urlDataFromLink.salesLevel = pair[1];
                } else if (pair[0] === 'taxDate') {
                    this.urlDataFromLink.taxDate = pair[1];
                }
                else if (pair[0] === 'driveType') {
                    this.urlDataFromLink.driveType = pair[1];
                }
                else if (pair[0] === 'materialGroupExt') {
                    this.urlDataFromLink.materialGroupExt = pair[1];
                }
                else if (pair[0] === 'hookURL') {
                    if (pair[2] !== undefined) {
                        this.urlDataFromLink.hookURL = pair[1] + "=" + pair[2];
                    } else {
                        this.urlDataFromLink.hookURL = pair[1];
                    }
                }
                //changes made to accomodate Modern DFE hookURL
                //starts here
               else if (pair[0] === "dealerId")
                    this.urlDataFromLink.hookURL = this.urlDataFromLink.hookURL + "&" + pair[0] + "=" + pair[1];
                else if (pair[0] === "mpc")
                    this.urlDataFromLink.hookURL = this.urlDataFromLink.hookURL + "&" + pair[0] + "=" + pair[1];
                else if (pair[0] === "lang")
                    this.urlDataFromLink.hookURL = this.urlDataFromLink.hookURL + "&" + pair[0] + "=" + pair[1];
                else if (pair[0] === "lob")
                    this.urlDataFromLink.hookURL = this.urlDataFromLink.hookURL + "&" + pair[0] + "=" + pair[1];
                else if (pair[0] === "authToken"){
                    this.urlDataFromLink.authToken = pair[1];
                    this.urlDataFromLink.hookURL = this.urlDataFromLink.hookURL + "&" + pair[0] + "=" + pair[1];
                }   
                //ends here
                else if (pair[0] === 'internalVehicleId') {
                    this.urlDataFromLink.internalVehicleId = pair[1];
                } else if (pair[0] === 'plant') {
                    this.urlDataFromLink.plant = pair[1];
                } else if (pair[0] === 'vehicleDescription') {
                    this.urlDataFromLink.vehicleDescription = pair[1];
                } else if (pair[0] === 'vehicleClass') {
                    this.urlDataFromLink.vehicleClass = pair[1];
                } else if (pair[0] === 'preSeriesModeFlag') {
                    this.urlDataFromLink.preSeriesModeFlag = pair[1];
                }

        }    
        return this.urlDataFromLink;
    }
    getCurrentDate() {
        let currentDate = new Date();
        let day = currentDate.getDate();
        let month = currentDate.getMonth() + 1;
        let year = currentDate.getFullYear();
        let prefixMonth: string = '';
        let prefixDay: string = '';
        if (month < 10) {
            prefixMonth = '0';
        }
        if (day < 10) {
            prefixDay = '0';
        }
        let date = (year + prefixMonth + month + prefixDay + day);
        return date;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/vehicle-info.service.ts